import axiosClient from 'utils/axiosClient';
import API from 'api';

const api = API.CANDIDATE;

interface LoginTypes {
	email: string;
	password: string;
}

interface RegTypes {}

const login = async (data: LoginTypes) => {
	const response = await axiosClient.post(api.AUTH.LOGIN, data);
	return response.data;
};

const register = async (data: RegTypes) => {
	const response = await axiosClient.post(api.AUTH.REGISTER, data);
	return response.data;
};

const confirmAccount = async (token: string) => {
	const response = await axiosClient.get(api.AUTH.CONFIRM + token);
	return response.data;
};

const forgotPassword = async (data: {email: string}) => {
	const response = await axiosClient.post(api.AUTH.FORGOT_PASSWORD, data);
	return response.data;
};

const resetPasword = async (token: string, data: {password: string; c_password: string}) => {
	const response = await axiosClient.post(api.AUTH.RESET_PASSWORD + token, data);
	return response.data;
};

const checkAdmission = async () => {
	const response = await axiosClient.get(api.AUTH.CHECK_ADMISSION);
	return response.data;
};

const service = {
	login,
	register,
	confirmAccount,
	forgotPassword,
	resetPasword,
	checkAdmission
};

export default service;
